import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';

import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { Pane, Dialog, Button, Label, Textarea, SelectField, Spinner } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import LocalPrintshopIcon from '@material-ui/icons//LocalPrintshop';
import { Form } from 'react-bootstrap';


// import { Form } from 'react-bootstrap';

// import Lottie from 'lottie-react-web';
// import animation from '../../assets/json/clean.json';
import 'react-toastify/dist/ReactToastify.css';
import { createMuiTheme } from '@material-ui/core/styles';

import * as moment from "moment-timezone";
import Login from '../common/login';
import exportFromJSON from 'export-from-json'
import DataTable from 'react-data-table-component';

const customStyles = {

    rows: {
        style: {
            minHeight: '72px', // override the row height
            border: 'solid 1px black'

        },
    },

    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            justifyContent: 'center',
            ' font-size': '25px',
            'font-weight': 'bold',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            border: 'solid 1px black',
            ' font-size': '20px',
            'font-weight': 'bold',
            justifyContent: 'center',
        },
    },
};
const conditionalRowStyles = [
    {
        when: row => row.replacement,
        style: {
            backgroundColor: "#343a40",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.check,
        style: {
            backgroundColor: "#ffc107",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.seleced,
        style: {
            backgroundColor: "#2E86C1",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.out,
        style: {
            backgroundColor: "#b50e1e",
            userSelect: "none",
            color: 'white'
        }
    },
];

const columns = [
    {
        name: 'المتبقي',
        selector: row => row.items_av,
        sortable: true,

        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}><p id={row.id} /></div>


    },
    {
        name: 'المادة',
        selector: row => row.notes2,
        sortable: true,

        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{row.notes2}</div>


    },
    {
        name: 'ملاحظات',
        selector: row => row.notes,
        sortable: true,
        width: "225px",
        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{row.notes}</div>

    },

    {
        name: 'السعر',
        selector: row => row.price,
        sortable: true,
        width: "120px",
    },
    {
        name: 'العنوان',
        selector: row => row.government + " / " + row.city,
        sortable: true,
        width: "305px",
        textAlign: "center",
        cell: row => <div style={{ fontSize: 15, textAlign: "center" }}>{row.government + " / " + row.city}</div>

    },
    {
        name: 'رقم الهاتف',
        selector: row => row.phone,
        width: "200px",

    },
    {
        name: 'التاريخ',
        selector: row => row.add_at,
        sortable: true,
        width: "225px",
        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{moment(row.add_at).tz('Asia/baghdad').format('YYYY/MM/DD LT')}</div>

    },
    {
        name: ' الوصل',
        selector: row => row.id,
        sortable: true,
        width: "150px",
    },
];
let counts = []

// تطبيع خفيف لاسم المحافظة — قصّ وتقليص المسافات فقط، بلا توحيد أسماء.
// (ميسان/العمارة و ذي قار/الناصرية يبقيان صفّين منفصلين — مقصود)
const normG = (raw) => String(raw === null || raw === undefined ? '' : raw).replace(/\s+/g, ' ').trim();

// تطبيع للمقارنة فقط — يوحّد الهمزة والتشكيل والتاء المربوطة والألف المقصورة
const simKey = (g) => String(g || '')
    .replace(/[\u064B-\u0652\u0670]/g, '')
    .replace(/[\u0623\u0625\u0622\u0671]/g, '\u0627')
    .replace(/\u0629/g, '\u0647')
    .replace(/\u0649/g, '\u064a')
    .replace(/\s+/g, '');

// المحافظات الشمالية وكل صيغها المتفرّعة — تُعزل بمجموعة لحالها
const NORTH = {};
['اربيل', 'أربيل', 'إربيل', 'هولير', 'هه ولير',
    'السليمانية', 'سليمانية', 'السليمانيه', 'سليماني',
    'دهوك', 'دوهك', 'دهوك'].forEach(n => { NORTH[simKey(n)] = true; });
const isNorth = (g) => !!NORTH[simKey(g)];

const cookies = new Cookies();
let id = 0
class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            ordes2: [],
            shiper: [],
            id: '',
            ids: [],
            company: 'none',
            selectedData: [],
            price: 0,
            isLoading: true, // للسبنر عند تحميل البيانات
            isPrinting: false, // للسبنر عند الطباعة

            // ⚖️ موازِن التوصيل
            balOpen: false,
            balTarget: '3.5',
            balBaghdadPrice: '3',
            balBaghdadAvail: 0,
            balGovs: [],        // [{ government, avail, checked, price }]
            balItems: [],       // [{ id, name, stock, wanted, orders, checked }]
            balPreview: null,   // نتيجة الحساب قبل التأشير
            balApplied: null,   // ملخّص آخر تأشير
            balPriceMap: null,  // { محافظة: سعر } — يغذّي حساب «المبلغ»
            balCompany: 'none',
            balNorthPrice: '',
            balBaghdadPct: null,   // null ⟵ تلقائي: أقل ما يحقق السقف
            balSortGov: 'orders', balSortGovDir: -1,
            balSortItem: 'wanted', balSortItemDir: -1
        }

        this.Orders()

    }
    rowSelect(data) {

        var Data = data.data;
        var row = data.rowsSelected;

        let ids = []
        for (let index = 0; index < row.length; index++) {
            let id = Data[index].data.id

            ids.push(id)
        }
        this.setState({ ids })
        // for (let index = 0; index < row.length; index++) {
        //     const element = array[index];

        // } 
        // this.setState({
        //     TableIndex: row,
        //     TableData: Data,
        //     button: true,
        // })
    }
    handleRowClicked(row) {

        let data = this.state.orders
        for (let index = 0; index < data.length; index++) {

            if (data[index].id === row.id) {
                data[index].seleced = !data[index].seleced
            }

        }

        this.setState({ orders: data })
    }




    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                // root: {
                //     //   backgroundColor: "#FF0000",
                //     textAlign: 'center',
                //     fontSize: '25px',
                //     fontWeight: 'bold',
                //     border: '2px solid'

                // },

            },

            MuiTableCell: {
                root: {
                    textAlign: 'right',

                },
                // head: {
                //     // backgroundColor: "#FF0000",
                //     textAlign: 'center',
                //     fontWeight: 'bold',
                //     fontSize: '25px',
                //     border: '2px solid'
                // }
            },

        }
    })

    Orders() {
        this.setState({ isLoading: true }); // بدء السبنر

        var header = { "Content-Type": "application/json", token: cookies.get("token") };

        // تحميل البيانات بشكل متزامن
        Promise.all([
            axios.get(host + `dashbord/shiper/all/`, { headers: header }),
            axios.get(host + `users/orders/prints/all`, { headers: header })
        ]).then(([shipersRes, ordersRes]) => {
            // معالجة بيانات المناديب
            this.setState({ shiper: shipersRes.data.shiper })

            // معالجة بيانات الطلبات
            let arr = [];
            let items = ordersRes.data.data.orders
            console.log(ordersRes.data.data.orders[0]);
            counts = ordersRes.data.data.counts
            let ordes2 = []
            for (let i = 0; i < items.length; i++) {
                items[i].address = items[i].government + "/" + items[i].city;
                items[i].seleced = false;
                items[i].out = false;
                arr.push(items[i]);
            }

            this.setState({
                orders_count: items.length,
                orders: items,
                spin: false,
                total_items: ordersRes.data.data.items_sum,
                total_orders: ordersRes.data.data.order_count,
                items_cost: ordersRes.data.data.items_cost,
                orders_cost: ordersRes.data.data.sells,
                ordes2,
                isLoading: false // إيقاف السبنر
            });
        }).catch(error => {
            console.log(error)
            this.setState({ isLoading: false }); // إيقاف السبنر حتى في حالة الخطأ
            toast.error("حدث خطأ في تحميل البيانات", {
                position: "top-center",
                autoClose: 3000,
            });
        });
    }
    handleChangeFrom = date => {


        this.setState({
            from: date
        });
    };
    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };
    download() {
        const data = this.state.ordes2
        const fileName = `${moment(new Date()).format('YYYY-MM-DD')}/${id}`
        const exportType = exportFromJSON.types.xls

        exportFromJSON({ data, fileName, exportType })
    }
    // ════════════════════════════════════════════════════════════════════════
    // ⚖️ موازِن التوصيل
    //    تختار المحافظات الغالية، والموازِن يحسب كم طلب بغداد يلزم كي يطلع
    //    المعدّل المرجّح أقرب ما يمكن للهدف، ثم يؤشّر الطلبات.
    // ════════════════════════════════════════════════════════════════════════

    /** سعر التوصيل المعتمد لمحافظة — من خريطة الموازِن، وإلا 5 (السلوك القديم) */
    shipPriceFor = (government, overrideMap) => {
        const m = overrideMap || this.state.balPriceMap;
        if (m) {
            const v = m[normG(government)];
            if (v !== undefined && v !== null && isFinite(Number(v))) return Number(v);
        }
        return 5;
    }

    /**
     * المخزون الأساسي = دفتر counts الحالي + كل ما هو مؤشَّر الآن.
     * counts متغيّر على مستوى الوحدة ويُخصم منه عند التأشير، فلازم نرجّعه
     * لنقطة الصفر قبل أي محاكاة وإلا حسبنا الخصم مرتين.
     */
    stockBaseline = () => {
        const base = {};
        counts.forEach(c => { base[c.id] = Number(c.count) || 0; });
        (this.state.selectedData || []).forEach(row => {
            (row.ordersFormItems || []).forEach(it => {
                const id = it.components.id;
                if (base[id] !== undefined) base[id] = base[id] + it.count;
            });
        });
        return base;
    }

    /** الطلبات المؤهّلة: بضاعتها موجودة وقت التحميل، وكل موادها مختارة */
    eligibleOrders = (items) => {
        const on = {};
        (items || []).forEach(it => { if (it.checked) on[it.id] = true; });
        return this.state.orders.filter(o => {
            if (o.check) return false;
            const list = o.ordersFormItems || [];
            if (list.length === 0) return false;
            for (let i = 0; i < list.length; i++) {
                if (!on[list[i].components.id]) return false;
            }
            return true;
        });
    }

    /** يعيد بناء جدول المحافظات من الطلبات المؤهّلة مع حفظ الاختيار والسعر */
    buildGovs = (eligible, prevGovs) => {
        const tally = {};
        let baghdadAvail = 0;
        eligible.forEach(o => {
            const g = normG(o.government);
            if (g === 'بغداد') { baghdadAvail++; return; }
            tally[g] = (tally[g] || 0) + 1;
        });

        const prev = {};
        (prevGovs || []).forEach(r => { prev[r.government] = r; });

        const govs = Object.keys(tally)
            .sort((a, b) => tally[b] - tally[a])
            .map(g => ({
                government: g,
                avail: tally[g],
                checked: prev[g] ? prev[g].checked : false,
                price: prev[g] ? prev[g].price : ''
            }));

        return { govs, baghdadAvail };
    }

    openBalance = () => {
        const base = this.stockBaseline();

        // المواد الموجودة بالطلبات المعلّقة — مع المتاح وعدد الطلبات اللي تريدها
        const seen = {};
        this.state.orders.forEach(o => {
            if (o.check) return;
            (o.ordersFormItems || []).forEach(it => {
                const c = it.components;
                if (!seen[c.id]) {
                    seen[c.id] = { id: c.id, name: c.name, stock: base[c.id] !== undefined ? base[c.id] : Number(c.count) || 0, wanted: 0, orders: 0 };
                }
                seen[c.id].wanted += it.count;
                seen[c.id].orders += 1;
            });
        });

        const prevItems = {};
        (this.state.balItems || []).forEach(it => { prevItems[it.id] = it.checked; });

        const items = Object.keys(seen)
            .map(k => seen[k])
            .sort((a, b) => b.orders - a.orders)
            .map(it => Object.assign({}, it, {
                checked: prevItems[it.id] === undefined ? true : prevItems[it.id]
            }));

        const eligible = this.eligibleOrders(items);
        const built = this.buildGovs(eligible, this.state.balGovs);

        this.setState({
            balOpen: true,
            balBaghdadPct: null,
            balItems: items,
            balGovs: built.govs,
            balBaghdadAvail: built.baghdadAvail,
            balPreview: this.computePreview(
                built.govs, this.state.balBaghdadPrice, this.state.balTarget,
                built.baghdadAvail, eligible, base, null
            )
        });
    }

    /** تعبئة الأسعار من آخر تسعير محفوظ للمندوب */
    loadBalanceDefaults = (company) => {
        this.setState({ balCompany: company });
        if (!company || company === 'none') return;

        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `users/shipping/defaults?company=${encodeURIComponent(company)}`, { headers: header })
            .then(res => {
                const d = res.data.data || {};
                if (!d.has_shiper) {
                    toast.error('المندوب غير مسجّل بجدول شركات التوصيل', { position: "top-center", autoClose: 3000 });
                    return;
                }
                const saved = {};
                (d.governments || []).forEach(g => { saved[normG(g.government)] = g.price; });

                const govs = this.state.balGovs.map(r => {
                    const v = saved[r.government] !== undefined ? saved[r.government] : d.other_price;
                    return Object.assign({}, r, { price: (v === null || v === undefined) ? r.price : String(v) });
                });
                const bg = saved['بغداد'] !== undefined ? saved['بغداد'] : d.b_price;

                this.patchBalance({
                    balGovs: govs,
                    balBaghdadPrice: (bg === null || bg === undefined) ? this.state.balBaghdadPrice : String(bg)
                });
            })
            .catch(() => {
                toast.error('تعذّر جلب الأسعار المحفوظة', { position: "top-center", autoClose: 3000 });
            });
    }

    /**
     * تطبيع للمقارنة البصرية فقط — يكشف الصيغ المتشابهة (اربيل / أُربيل).
     * ⚠️ لا يُستعمل بالتجميع ولا بالكتابة — السعر ينكتب على النص الخام كما هو.
     */
    similarKey = simKey;

    /**
     * الحساب — دالة صافية ترجّع المعاينة **والطلبات المختارة فعلاً**،
     * فالمعاينة واللي ينطبّق هما نفس الشي بالضبط لا حسابان متوازيان.
     *
     * المحافظات المختارة هي المرساة (تُؤخذ كاملة)، وبغداد هي المتغيّر.
     *
     * الهدف **سقف** لا رقم يُصاب: أقل عدد بغداد يخلّي المعدّل ≤ السقف هو
     *     nMin = ⌈ (C − T·N) ÷ (T − b) ⌉
     * وبغداد مورد مشترك بين شركات التوصيل، فالافتراضي ياخذ nMin بالضبط
     * ويترك الباقي للشركات الثانية. والنسبة (pct) مقبض يدوي يسمح بالزيادة
     * أو النقصان عن هذا الحد.
     *
     * ⚠️ نقص المخزون **لا يستبعد** طلباً: نؤشّره ونعلّمه أحمر (قرار مثبَّت).
     *    الأولوية عند الشح: المحافظات المختارة أولاً ثم بغداد.
     */
    computePreview = (govs, baghdadPriceRaw, targetRaw, availB, eligible, baseStock, pct) => {
        const T = Number(targetRaw);
        const b = Number(baghdadPriceRaw);
        const picked = (govs || []).filter(g => g.checked);

        if (targetRaw === '' || !isFinite(T) || T <= 0) return { error: 'حدّد سقف المعدّل' };
        if (baghdadPriceRaw === '' || !isFinite(b) || b < 0) return { error: 'حدّد سعر توصيل بغداد' };
        if (picked.length === 0) return { error: 'اختر محافظة وحدة على الأقل' };
        for (let i = 0; i < picked.length; i++) {
            const pr = Number(picked[i].price);
            if (picked[i].price === '' || !isFinite(pr) || pr < 0) {
                return { error: 'سعر غير صالح للمحافظة: ' + (picked[i].government || '(بدون محافظة)') };
            }
        }

        let N = 0, C = 0;
        picked.forEach(g => { N += g.avail; C += g.avail * Number(g.price); });

        const deficit = C - T * N;                 // > 0 ⟵ المرساة فوق السقف
        const cheaper = (T - b) > 1e-9;            // بغداد أرخص من السقف فتنزّل المعدّل

        // أقل عدد بغداد يخلّي المعدّل ضمن السقف
        let needMin;
        if (deficit <= 1e-9) needMin = 0;          // المرساة ضمن السقف أصلاً
        else if (!cheaper) needMin = Infinity;     // بغداد ما تنزّل شي
        else needMin = Math.ceil(deficit / (T - b) - 1e-9);

        const reachable = isFinite(needMin) && needMin <= availB;
        const minCount = Math.min(isFinite(needMin) ? needMin : availB, availB);
        const minPct = availB > 0 ? Math.min(100, Math.ceil((minCount / availB) * 100)) : 0;

        // pct = null ⟵ تلقائي: أقل ما يحقق السقف (يوفّر حصة الشركات الثانية)
        const auto = (pct === null || pct === undefined || pct === '');
        const n = auto
            ? minCount
            : Math.max(0, Math.min(availB, Math.round((Number(pct) / 100) * availB)));

        const avg = (N + n) > 0 ? (C + n * b) / (N + n) : 0;
        const withinCeiling = avg <= T + 1e-9;

        const best = { n, avg };

        const rows = picked.map(g => ({ government: g.government, count: g.avail, price: Number(g.price) }));
        if (best.n > 0) rows.push({ government: 'بغداد', count: best.n, price: b, isAnchor: true });

        // ── اختيار الطلبات: المرساة أولاً ثم بغداد، والأقدم أولاً داخل كل محافظة ──
        const pool = eligible || [];
        const chosen = [];
        rows.forEach(r => {
            const mine = pool
                .filter(o => normG(o.government) === r.government)
                .sort((a, c) => new Date(a.add_at) - new Date(c.add_at));
            chosen.push.apply(chosen, mine.slice(0, r.count));
        });

        // ── محاكاة دفتر المخزون بنفس الترتيب اللي راح ينطبّق ──
        const ledger = Object.assign({}, baseStock || {});
        const shortIds = {};
        const shortByItem = {};
        chosen.forEach(o => {
            let rowShort = false;
            (o.ordersFormItems || []).forEach(it => {
                const id = it.components.id;
                if (ledger[id] === undefined) return;
                ledger[id] = ledger[id] - it.count;
                if (ledger[id] < 0) {
                    rowShort = true;
                    if (!shortByItem[id]) {
                        shortByItem[id] = { id, name: it.components.name, stock: (baseStock || {})[id] || 0, missing: 0 };
                    }
                }
            });
            if (rowShort) shortIds[o.id] = true;
        });
        Object.keys(shortByItem).forEach(id => {
            shortByItem[id].missing = Math.abs(Math.min(0, ledger[id]));
        });
        const shortItems = Object.keys(shortByItem).map(k => shortByItem[k]);
        const shortCount = Object.keys(shortIds).length;

        // ── تحذير واحد فقط، الأهم ──────────────────────────────────────────
        const warnings = [];
        if (!cheaper && deficit > 1e-9) {
            warnings.push(`سعر بغداد ${b} مو أقل من السقف ${T} — ما ينزّل المعدّل مهما زدت النسبة.`);
        } else if (!reachable && deficit > 1e-9) {
            warnings.push(`السقف ${T} غير قابل للتحقيق: يلزم ${needMin} طلب بغداد والمتاح ${availB}.`);
        } else if (!withinCeiling) {
            warnings.push(`المعدّل ${Math.round(avg * 100) / 100} فوق السقف — ارفع نسبة بغداد لـ ${minPct}% (${minCount} طلب).`);
        }

        // ── صيغ متشابهة لنفس المحافظة (اربيل / أُربيل) ────────────────────
        const byKey = {};
        (govs || []).forEach(g => {
            const k = this.similarKey(g.government);
            if (!k) return;
            (byKey[k] = byKey[k] || []).push(g.government);
        });
        const lookalikes = Object.keys(byKey)
            .filter(k => byKey[k].length > 1)
            .map(k => byKey[k]);

        return {
            rows,
            chosen,
            baghdadCount: best.n,
            baghdadAvail: availB,
            anchorOrders: N,
            totalOrders: N + best.n,
            shipTotal: Math.round((C + best.n * b) * 100) / 100,
            avg: Math.round(best.avg * 10000) / 10000,
            target: T,
            gap: Math.round((best.avg - T) * 10000) / 10000,
            onTarget: withinCeiling,
            withinCeiling,
            minCount,
            minPct,
            needMin: isFinite(needMin) ? needMin : null,
            reachable,
            pctAuto: auto,
            pct: availB > 0 ? Math.round((best.n / availB) * 100) : 0,
            baghdadLeft: availB - best.n,
            shortCount,
            shortItems,
            warnings,
            lookalikes
        };
    }

    computeBalance = () => {
        this.setState({
            balPreview: this.computePreview(
                this.state.balGovs, this.state.balBaghdadPrice, this.state.balTarget,
                this.state.balBaghdadAvail,
                this.eligibleOrders(this.state.balItems), this.stockBaseline(),
                this.state.balBaghdadPct
            )
        });
    }

    /**
     * أي تبديل يعيد الحساب فوراً — المعاينة حيّة بلا زر.
     * تبديل المواد يعيد بناء جدول المحافظات كذلك، لأن المؤهّلين تغيّروا.
     */
    patchBalance = (patch) => {
        const base = this.stockBaseline();
        let govs = patch.balGovs !== undefined ? patch.balGovs : this.state.balGovs;
        let availB = this.state.balBaghdadAvail;
        const items = patch.balItems !== undefined ? patch.balItems : this.state.balItems;

        const eligible = this.eligibleOrders(items);

        if (patch.balItems !== undefined) {
            const built = this.buildGovs(eligible, govs);
            govs = built.govs;
            availB = built.baghdadAvail;
        }

        const bPrice = patch.balBaghdadPrice !== undefined ? patch.balBaghdadPrice : this.state.balBaghdadPrice;
        const target = patch.balTarget !== undefined ? patch.balTarget : this.state.balTarget;

        const pct = patch.balBaghdadPct !== undefined ? patch.balBaghdadPct : this.state.balBaghdadPct;

        this.setState(Object.assign({}, patch, {
            balGovs: govs,
            balBaghdadAvail: availB,
            balPreview: this.computePreview(govs, bPrice, target, availB, eligible, base, pct)
        }));
    }

    setBalGov = (i, patch) => {
        const govs = this.state.balGovs.slice();
        govs[i] = Object.assign({}, govs[i], patch);
        this.patchBalance({ balGovs: govs });
    }

    setBalItem = (i, checked) => {
        const items = this.state.balItems.slice();
        items[i] = Object.assign({}, items[i], { checked });
        this.patchBalance({ balItems: items });
    }

    /** فرز المحافظات ثم فصل الشمالية عن الباقي */
    sortedGovGroups = () => {
        const key = this.state.balSortGov, dir = this.state.balSortGovDir;
        const val = (g) => key === 'name' ? g.government
            : key === 'price' ? (g.price === '' ? -1 : Number(g.price))
                : g.avail;
        const cmp = (a, b) => {
            const x = val(a), y = val(b);
            if (typeof x === 'string') return dir * x.localeCompare(y, 'ar');
            return dir * (x - y);
        };
        const all = this.state.balGovs.slice();
        return {
            north: all.filter(g => isNorth(g.government)).sort(cmp),
            rest: all.filter(g => !isNorth(g.government)).sort(cmp)
        };
    }

    sortedItems = () => {
        const key = this.state.balSortItem, dir = this.state.balSortItemDir;
        const val = (it) => key === 'name' ? it.name
            : key === 'stock' ? it.stock
                : key === 'short' ? (it.wanted - it.stock)
                    : it.wanted;
        return this.state.balItems.slice().sort((a, b) => {
            const x = val(a), y = val(b);
            if (typeof x === 'string') return dir * x.localeCompare(y, 'ar');
            return dir * (x - y);
        });
    }

    toggleSort = (which, key) => {
        if (which === 'gov') {
            this.setState(st => ({
                balSortGov: key,
                balSortGovDir: st.balSortGov === key ? -st.balSortGovDir : (key === 'name' ? 1 : -1)
            }));
        } else {
            this.setState(st => ({
                balSortItem: key,
                balSortItemDir: st.balSortItem === key ? -st.balSortItemDir : (key === 'name' ? 1 : -1)
            }));
        }
    }

    /** تأشير/إلغاء مجموعة محافظات دفعة وحدة */
    setGovGroup = (list, checked) => {
        const names = {};
        list.forEach(g => { names[g.government] = true; });
        this.patchBalance({
            balGovs: this.state.balGovs.map(g =>
                names[g.government] ? Object.assign({}, g, { checked }) : g)
        });
    }

    /** سعر موحّد لمجموعة */
    setGovGroupPrice = (list, price) => {
        const names = {};
        list.forEach(g => { names[g.government] = true; });
        this.patchBalance({
            balGovs: this.state.balGovs.map(g =>
                names[g.government] ? Object.assign({}, g, { price: price }) : g)
        });
    }

    setAllItems = (checked) => {
        this.patchBalance({
            balItems: this.state.balItems.map(it => Object.assign({}, it, { checked }))
        });
    }



    /** تأشير الطلبات حسب المعاينة — الأقدم أولاً داخل كل محافظة */
    applyBalance = () => {
        const p = this.state.balPreview;
        if (!p || p.error || !p.rows) return;

        // نفس الطلبات اللي عرضتها المعاينة بالضبط — لا إعادة اختيار
        const chosen = p.chosen || [];

        const priceMap = {};
        p.rows.forEach(r => { priceMap[r.government] = r.price; });

        this.applySelection(chosen, priceMap);
        this.setState({
            balOpen: false,
            balApplied: { count: chosen.length, avg: p.avg, target: p.target }
        });

        const shortNote = p.shortCount > 0 ? ` · ${p.shortCount} ناقص بضاعة` : '';
        toast.success(`تم تأشير ${chosen.length} طلب — المعدّل ${Math.round(p.avg * 100) / 100}${shortNote}`, {
            position: "top-center", autoClose: 4000
        });
    }

    /**
     * تأشير جماعي يستبدل التحديد الحالي بالكامل.
     * ⚠️ لا يجوز استدعاء handleRowClicked بحلقة: الدالة تقرأ this.state.selectedData
     *    بداخلها و setState غير متزامنة، فالحلقة تنتهي بصفّ واحد مؤشَّر.
     *    هنا نمسك نفس دفتر المخزون (counts) ونفس الكتابة بالـDOM مرة واحدة.
     */
    applySelection = (rows, priceMap) => {
        // ١) ترجيع دفتر المخزون لكل ما هو مؤشَّر حالياً
        (this.state.selectedData || []).forEach(row => {
            (row.ordersFormItems || []).forEach(item => {
                const i = counts.findIndex(o => o.id == item.components.id);
                if (i >= 0) counts[i].count = counts[i].count + item.count;
            });
            const el = document.getElementById(row.id);
            if (el) el.innerText = "";
        });

        // ٢) خصم الجديد وبناء خلايا «المتبقي»
        const outIds = {};
        const selected = [];
        (rows || []).forEach(row => {
            const el = document.getElementById(row.id);
            if (el) el.innerText = "";
            let rowOut = false;

            (row.ordersFormItems || []).forEach(item => {
                const i = counts.findIndex(o => o.id == item.components.id);
                if (i < 0) return;
                counts[i].count = counts[i].count - item.count;

                const span = document.createElement('p');
                span.className = 'content';
                span.appendChild(document.createTextNode(`${item.components.name} :${counts[i].count}`));
                if (counts[i].count < 0) { rowOut = true; span.style.color = "#ffc107"; }
                else { span.style.color = "#fafafa"; }
                if (el) el.appendChild(span);
            });

            if (rowOut) outIds[row.id] = true;
            selected.push(row);
        });

        const selIds = {};
        selected.forEach(r => { selIds[r.id] = true; });

        let t_price = 0;
        selected.forEach(r => { t_price += Number(r.price) - this.shipPriceFor(r.government, priceMap); });

        const updated = this.state.orders.map(o => Object.assign({}, o, {
            seleced: !!selIds[o.id],
            out: !!outIds[o.id]
        }));

        this.setState({
            orders: updated,
            selectedData: selected,
            price: Math.round(t_price * 100) / 100,
            balPriceMap: priceMap || this.state.balPriceMap
        });
    }

    clearSelection = () => {
        this.applySelection([], this.state.balPriceMap);
        this.setState({ balApplied: null });
    }

    /**
     * الميزان — العنصر المميّز بالنافذة.
     * محور أسعار من الأرخص (يمين) للأغلى (يسار)، عليه علامة الهدف ومؤشّر
     * المعدّل الناتج، وتحته أثقال بعرض يتناسب مع عدد طلبات كل سعر.
     * يقرأ بلمحة: وين وقف المعدّل من الهدف، ومنو يسحبه.
     */
    /**
     * لوحة القياس — شريط داكن أعلى النافذة يحمل القراءة والميزان.
     * محور أسعار من الأرخص (يمين) للأغلى (يسار)، عليه علامة الهدف ومؤشّر
     * المعدّل، وتحته أثقال بارتفاع يتناسب مع عدد طلبات كل سعر.
     */
    renderBalanceScale = (p) => {
        const prices = p.rows.map(r => r.price).concat([p.target, p.avg]);
        let lo = Math.min.apply(null, prices);
        let hi = Math.max.apply(null, prices);
        const pad = Math.max((hi - lo) * 0.22, 0.2);
        lo -= pad; hi += pad;
        const pos = (v) => ((v - lo) / (hi - lo)) * 100;

        const byPrice = {};
        p.rows.forEach(r => {
            const k = String(r.price);
            if (!byPrice[k]) byPrice[k] = { price: r.price, count: 0, anchor: false };
            byPrice[k].count += r.count;
            if (r.isAnchor) byPrice[k].anchor = true;
        });
        const weights = Object.keys(byPrice).map(k => byPrice[k]);
        const maxCount = Math.max.apply(null, weights.map(w => w.count).concat([1]));

        return (
            <div className="mzn-gauge">
                <div className="mzn-readout">
                    <div className="mzn-read-main">
                        <span className="mzn-read-label">المعدّل الناتج</span>
                        <b className={'mzn-read-val ' + (p.onTarget ? 'is-ok' : 'is-off')}>
                            {Math.round(p.avg * 10000) / 10000}
                        </b>
                    </div>
                    <div className="mzn-read-side">
                        <span>السقف <b>{p.target}</b></span>
                        <span className={p.onTarget ? 'is-ok' : 'is-off'}>
                            {p.gap > 0 ? '+' : ''}{Math.round(p.gap * 10000) / 10000}
                        </span>
                    </div>
                    <div className="mzn-read-side">
                        <span>{p.totalOrders} طلب</span>
                        <span>أجور {p.shipTotal}</span>
                    </div>
                </div>

                <div className="mzn-beam">
                    {weights.map((w, i) => (
                        <div key={i}
                            className={'mzn-weight ' + (w.anchor ? 'is-anchor' : 'is-load')}
                            style={{ right: pos(w.price) + '%', height: Math.max(6, (w.count / maxCount) * 34) + 'px' }}>
                            <span className="mzn-weight-count">{w.count}</span>
                        </div>
                    ))}
                    <div className="mzn-axis" />
                    <div className="mzn-target" style={{ right: pos(p.target) + '%' }} />
                    <div className={'mzn-needle ' + (p.onTarget ? 'is-ok' : 'is-off')}
                        style={{ right: pos(p.avg) + '%' }} />
                </div>

                <div className="mzn-legend">
                    <span><i className="mzn-dot is-anchor" />بغداد {p.baghdadCount} من {p.baghdadAvail}</span>
                    <span><i className="mzn-dot is-load" />المحافظات {p.anchorOrders}</span>
                    <span className="mzn-legend-ends">أغلى ← → أرخص</span>
                </div>

                {p.baghdadAvail > 0 && (
                    <div className="mzn-share">
                        <div className="mzn-share-top">
                            <span className="mzn-share-label">حصة بغداد بهذا الكشف</span>
                            <span className="mzn-share-val">
                                <b>{p.pct}%</b> · {p.baghdadCount} طلب
                                {p.pctAuto && <em className="mzn-auto">تلقائي</em>}
                            </span>
                            <span className="mzn-share-left">
                                يبقى <b>{p.baghdadLeft}</b> للشركات الثانية
                            </span>
                        </div>

                        <div className="mzn-slider-wrap">
                            <input type="range" min="0" max="100" step="1" className="mzn-slider"
                                value={p.pct}
                                aria-label="نسبة طلبات بغداد"
                                onChange={(e) => this.patchBalance({ balBaghdadPct: Number(e.target.value) })} />
                            {p.reachable && (
                                <div className="mzn-min-mark" style={{ right: p.minPct + '%' }}
                                    title={`أقل نسبة تحقق السقف: ${p.minPct}%`} />
                            )}
                        </div>

                        <div className="mzn-share-foot">
                            {p.reachable
                                ? <span>الحد الأدنى للسقف <b>{p.minPct}%</b> ({p.minCount} طلب)</span>
                                : <span className="is-off">السقف غير قابل للتحقيق بالمتاح</span>}
                            {!p.pctAuto && (
                                <button type="button" className="mzn-reset"
                                    onClick={() => this.patchBalance({ balBaghdadPct: null })}>
                                    رجّع للتلقائي
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    /** ترويسة عمود قابلة للفرز */
    sortTh = (which, key, label, cls) => {
        const active = which === 'gov' ? this.state.balSortGov === key : this.state.balSortItem === key;
        const dir = which === 'gov' ? this.state.balSortGovDir : this.state.balSortItemDir;
        return (
            <th className={(cls || '') + ' mzn-th-sort' + (active ? ' is-active' : '')}
                onClick={() => this.toggleSort(which, key)}
                title="اضغط للفرز">
                {label}<span className="mzn-caret">{active ? (dir === 1 ? '▲' : '▼') : ''}</span>
            </th>
        );
    }

    /** صفوف مجموعة محافظات */
    renderGovRows = (list) => {
        const all = this.state.balGovs;
        return list.map((g) => {
            const i = all.indexOf(g);
            const fees = g.checked && g.price !== '' ? Math.round(g.avail * Number(g.price) * 100) / 100 : null;
            return (
                <tr key={g.government} className={'mzn-row ' + (g.checked ? 'is-on' : '')}>
                    <td>
                        <label className="mzn-name">
                            <input type="checkbox" className="mzn-chk" checked={g.checked}
                                onChange={(e) => this.setBalGov(i, { checked: e.target.checked })} />
                            {g.government || <span className="mzn-muted">(بدون محافظة)</span>}
                        </label>
                    </td>
                    <td className="mzn-n">{g.avail}</td>
                    <td className="mzn-n">
                        <input type="text" inputMode="decimal" value={g.price}
                            className={'mzn-mini ' + (g.checked && g.price === '' ? 'is-blank' : '')}
                            onChange={(e) => {
                                const v = e.target.value;
                                if (v === '' || /^\d*\.?\d*$/.test(v)) this.setBalGov(i, { price: v });
                            }} />
                    </td>
                    <td className="mzn-n mzn-muted">{fees === null ? '—' : fees}</td>
                </tr>
            );
        });
    }

    renderBalanceDialog = () => {
        const s = this.state;
        const p = s.balPreview;
        const ready = p && !p.error && p.totalOrders > 0;
        const groups = this.sortedGovGroups();
        const items = this.sortedItems();
        const northOn = groups.north.length > 0 && groups.north.every(g => g.checked);

        return (
            <Dialog
                isShown={s.balOpen}
                title="موازنة أسعار التوصيل"
                onCloseComplete={() => this.setState({ balOpen: false })}
                confirmLabel={ready ? `تأشير ${p.totalOrders} طلب` : 'تأشير الطلبات'}
                cancelLabel="إغلاق"
                isConfirmDisabled={!ready}
                onConfirm={this.applyBalance}
                width={1100}
            >
                <style>{`
.mzn { direction: rtl; text-align: right;
  --ink:#16202E; --ink2:#64748B; --line:#E6EBF2; --wash:#F8FAFC;
  --anchor:#0E7C6B; --load:#B4530C; --target:#7DA2FF; --ok:#35B37E; --short:#C0341D;
  color: var(--ink);
  font-family: 'Segoe UI','Noto Kufi Arabic',Tahoma,sans-serif;
  font-size:14px; line-height:1.5; }
.mzn .mzn-num, .mzn-n { font-variant-numeric: tabular-nums; }
.mzn .mzn-eyebrow { font-size:11px; font-weight:700; letter-spacing:.12em; color:var(--ink2); }

/* ══ لوحة القياس ══ */
.mzn-gauge { background:var(--ink); border-radius:12px; padding:16px 20px 12px;
  margin-bottom:14px; color:#E8EEF6; }
.mzn-readout { display:flex; align-items:flex-end; gap:32px; flex-wrap:wrap; }
.mzn-read-main { display:flex; flex-direction:column; gap:0; }
.mzn-read-label { font-size:11px; font-weight:700; letter-spacing:.12em; color:#8FA3BD; }
.mzn-read-val { font-size:42px; font-weight:800; line-height:1.05; letter-spacing:-.03em;
  font-variant-numeric: tabular-nums; }
.mzn-read-val.is-ok { color:var(--ok); }
.mzn-read-val.is-off { color:#E2A03F; }
.mzn-read-side { display:flex; flex-direction:column; gap:3px; font-size:13px;
  color:#A9BBD1; padding-bottom:6px; font-variant-numeric: tabular-nums; }
.mzn-read-side b { color:#E8EEF6; font-weight:700; }
.mzn-read-side .is-ok { color:var(--ok); font-weight:700; }
.mzn-read-side .is-off { color:#E2A03F; font-weight:700; }

.mzn-beam { position:relative; height:58px; margin:14px 8px 0; }
.mzn-axis { position:absolute; right:0; left:0; top:40px; height:1px; background:#33435C; }
.mzn-weight { position:absolute; bottom:18px; width:14px; margin-right:-7px; border-radius:2px 2px 0 0; }
.mzn-weight.is-anchor { background:#2FA893; }
.mzn-weight.is-load { background:#D9863C; }
.mzn-weight-count { position:absolute; top:-16px; right:50%; transform:translateX(50%);
  font-size:11px; font-weight:700; color:#8FA3BD; font-variant-numeric: tabular-nums; }
.mzn-target { position:absolute; top:22px; height:26px; width:0;
  border-right:2px dashed var(--target); }
.mzn-needle { position:absolute; top:34px; width:0; height:0; margin-right:-6px;
  border-right:6px solid transparent; border-left:6px solid transparent;
  border-bottom:10px solid var(--ok); }
.mzn-needle.is-off { border-bottom-color:#E2A03F; }
.mzn-legend { display:flex; gap:18px; margin-top:10px; font-size:12px; color:#8FA3BD; }
.mzn-legend-ends { margin-right:auto; letter-spacing:.04em; }
.mzn-dot { display:inline-block; width:8px; height:8px; border-radius:2px; margin-left:6px; }
.mzn-dot.is-anchor { background:#2FA893; }
.mzn-dot.is-load { background:#D9863C; }
/* ── حصة بغداد ── */
.mzn-share { margin-top:12px; padding-top:11px; border-top:1px solid #2A3A50; }
.mzn-share-top { display:flex; align-items:baseline; gap:14px; flex-wrap:wrap;
  font-size:12px; color:#A9BBD1; }
.mzn-share-label { font-size:11px; font-weight:700; letter-spacing:.1em; color:#8FA3BD; }
.mzn-share-val { font-variant-numeric: tabular-nums; color:#E8EEF6; }
.mzn-share-val b { font-size:16px; font-weight:800; }
.mzn-auto { margin-right:7px; font-style:normal; font-size:10px; font-weight:700;
  letter-spacing:.08em; padding:1px 6px; border-radius:999px;
  background:#22344A; color:#8FA3BD; }
.mzn-share-left { margin-right:auto; font-variant-numeric: tabular-nums; }
.mzn-share-left b { color:#E8EEF6; }
.mzn-slider-wrap { position:relative; margin:9px 2px 0; }
.mzn-slider { width:100%; margin:0; accent-color:#2FA893; direction:rtl; cursor:pointer; }
.mzn-slider:focus-visible { outline:2px solid var(--target); outline-offset:3px; }
.mzn-min-mark { position:absolute; top:-3px; width:2px; height:20px;
  background:var(--target); margin-right:-1px; pointer-events:none; }
.mzn-share-foot { display:flex; align-items:center; gap:14px; margin-top:7px;
  font-size:11px; color:#8FA3BD; font-variant-numeric: tabular-nums; }
.mzn-share-foot b { color:var(--target); }
.mzn-share-foot .is-off { color:#E2A03F; }
.mzn-reset { margin-right:auto; background:none; border:1px solid #33435C;
  color:#A9BBD1; border-radius:6px; padding:2px 9px; font-size:11px; cursor:pointer;
  font-family:inherit; }
.mzn-reset:hover { border-color:#4A5E7A; color:#E8EEF6; }

.mzn-gauge-idle { background:var(--ink); border-radius:12px; padding:26px 20px;
  margin-bottom:14px; color:#8FA3BD; text-align:center; font-size:14px; }

/* ══ شريط الضبط ══ */
.mzn-controls { display:flex; flex-wrap:wrap; gap:20px; align-items:flex-end;
  padding:0 2px 14px; border-bottom:1px solid var(--line); margin-bottom:14px; }
.mzn-field { display:flex; flex-direction:column; gap:5px; }
.mzn-field > label { font-size:11px; font-weight:700; letter-spacing:.08em; color:var(--ink2); }
.mzn-in { border:1px solid #CBD5E1; border-radius:7px; padding:7px 10px;
  font-size:15px; font-weight:600; background:#fff; color:var(--ink);
  font-variant-numeric: tabular-nums; }
.mzn-in:focus-visible { outline:2px solid #2450C8; outline-offset:1px; }
.mzn-in.mzn-w { width:92px; text-align:center; }
.mzn-in.mzn-target-in { border-color:#2450C8; box-shadow: inset 0 -2px 0 #2450C8; }
.mzn-hint { font-size:11px; color:var(--ink2); }

/* ══ اللوحتان ══ */
.mzn-panes { display:flex; gap:14px; flex-wrap:wrap; align-items:flex-start; }
.mzn-pane { flex:1 1 380px; min-width:330px; border:1px solid var(--line);
  border-radius:10px; overflow:hidden; }
.mzn-pane-head { display:flex; justify-content:space-between; align-items:center;
  gap:10px; padding:9px 13px; background:var(--wash); border-bottom:1px solid var(--line); }
.mzn-scroll { max-height:340px; overflow-y:auto; }
.mzn-t { width:100%; border-collapse:collapse; font-size:14px; }
.mzn-t th { font-size:11px; font-weight:700; letter-spacing:.05em; color:var(--ink2);
  text-align:right; padding:7px 12px; border-bottom:1px solid var(--line); background:#fff;
  position:sticky; top:0; z-index:1; white-space:nowrap; }
.mzn-th-sort { cursor:pointer; user-select:none; }
.mzn-th-sort:hover { color:var(--ink); }
.mzn-th-sort.is-active { color:var(--ink); }
.mzn-caret { margin-right:3px; font-size:9px; }
.mzn-t td { padding:6px 12px; border-bottom:1px solid #F1F5F9; }
.mzn-t .mzn-n { text-align:center; }
.mzn-row.is-on { background:#F1F8F6; }
.mzn-row.is-off td { opacity:.42; }
.mzn-row.is-anchor td { background:#ECF6F3; font-weight:700; border-top:1px solid var(--line); }
.mzn-name { display:flex; align-items:center; gap:8px; cursor:pointer; margin:0; font-weight:400; }
.mzn-chk { width:15px; height:15px; accent-color:var(--anchor); cursor:pointer; }
.mzn-mini { border:1px solid #CBD5E1; border-radius:6px; padding:3px 6px; width:68px;
  text-align:center; font-variant-numeric: tabular-nums; font-weight:600; background:#fff; }
.mzn-mini:focus-visible { outline:2px solid #2450C8; outline-offset:1px; }
.mzn-mini.is-blank { border-color:var(--short); background:#FEF6F5; }
.mzn-muted { color:var(--ink2); font-size:12px; }

/* ── عنوان المجموعة ── */
.mzn-grp td { background:#F4F7FB; border-top:1px solid var(--line);
  border-bottom:1px solid var(--line); padding:5px 12px; }
.mzn-grp-in { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.mzn-grp-title { font-size:11px; font-weight:800; letter-spacing:.1em; color:#334155; }
.mzn-grp-act { display:flex; align-items:center; gap:6px; font-size:11px;
  font-weight:700; color:var(--anchor); cursor:pointer; margin:0; }
.mzn-grp-price { margin-right:auto; display:flex; align-items:center; gap:6px;
  font-size:11px; color:var(--ink2); }

.mzn-stock { font-weight:700; }
.mzn-stock.is-short { color:var(--short); }
.mzn-item-name { font-weight:600; }
.mzn-all { display:flex; align-items:center; gap:6px; font-size:12px;
  font-weight:700; color:var(--anchor); cursor:pointer; margin:0; }

/* ══ التنبيهات ══ */
.mzn-note { display:flex; gap:9px; margin-top:11px; padding:10px 13px;
  border-radius:9px; font-size:13px; line-height:1.6;
  background:#FFF8EE; border:1px solid #F0D4A8; color:#7A4A0B; }
.mzn-note.is-info { background:#F4F7FD; border-color:#D3DEF2; color:#2B3F64; }
.mzn-note.is-short { background:#FDECE9; border-color:#F3C4BB; color:#8E2718; }
.mzn-short-tag { display:inline-block; margin-right:6px; padding:1px 7px;
  border-radius:999px; font-size:11px; font-weight:700;
  background:#fff; color:var(--short); border:1px solid #F3C4BB; }
.mzn-empty { padding:26px 16px; text-align:center; color:var(--ink2); font-size:13px; }
.mzn-foot { margin-top:11px; font-size:12px; color:var(--ink2); line-height:1.7; }
@media (prefers-reduced-motion: no-preference) {
  .mzn-needle, .mzn-weight { transition: right .3s ease, height .3s ease; }
}
                `}</style>

                <div className="mzn">

                    {ready
                        ? this.renderBalanceScale(p)
                        : <div className="mzn-gauge-idle">{(p && p.error) || 'اختر محافظة وحدّد سعرها'}</div>}

                    <div className="mzn-controls">
                        <div className="mzn-field">
                            <label htmlFor="mzn-co">المندوب</label>
                            <select id="mzn-co" className="mzn-in" value={s.balCompany}
                                onChange={(e) => this.loadBalanceDefaults(e.target.value)}>
                                <option value="none">— بلا تعبئة —</option>
                                {(s.shiper || []).map((it, i) => (
                                    <option key={i} value={it.name}>{it.name}</option>
                                ))}
                            </select>
                            <span className="mzn-hint">يعبّي الأسعار من آخر تسعير محفوظ</span>
                        </div>
                        <div className="mzn-field">
                            <label htmlFor="mzn-bg">سعر بغداد</label>
                            <input id="mzn-bg" type="text" inputMode="decimal" className="mzn-in mzn-w"
                                value={s.balBaghdadPrice}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    if (v === '' || /^\d*\.?\d*$/.test(v)) this.patchBalance({ balBaghdadPrice: v });
                                }} />
                            <span className="mzn-hint">{s.balBaghdadAvail} طلب متاح</span>
                        </div>
                        <div className="mzn-field">
                            <label htmlFor="mzn-tg">سقف المعدّل</label>
                            <input id="mzn-tg" type="text" inputMode="decimal" className="mzn-in mzn-w mzn-target-in"
                                value={s.balTarget}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    if (v === '' || /^\d*\.?\d*$/.test(v)) this.patchBalance({ balTarget: v });
                                }} />
                            <span className="mzn-hint">المعدّل ما يتجاوزه</span>
                        </div>
                    </div>

                    <div className="mzn-panes">

                        {/* ── المحافظات ── */}
                        <div className="mzn-pane">
                            <div className="mzn-pane-head">
                                <span className="mzn-eyebrow">المحافظات</span>
                                <span className="mzn-muted">
                                    {s.balGovs.filter(g => g.checked).length} من {s.balGovs.length} مختارة
                                </span>
                            </div>
                            <div className="mzn-scroll">
                                {s.balGovs.length === 0 ? (
                                    <div className="mzn-empty">ما فيه طلبات معلّقة خارج بغداد</div>
                                ) : (
                                    <table className="mzn-t">
                                        <thead>
                                            <tr>
                                                {this.sortTh('gov', 'name', 'المحافظة')}
                                                {this.sortTh('gov', 'orders', 'طلبات', 'mzn-n')}
                                                {this.sortTh('gov', 'price', 'السعر', 'mzn-n')}
                                                <th className="mzn-n">الأجور</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groups.north.length > 0 && (
                                                <tr className="mzn-grp"><td colSpan={4}>
                                                    <div className="mzn-grp-in">
                                                        <span className="mzn-grp-title">الشمالية</span>
                                                        <label className="mzn-grp-act">
                                                            <input type="checkbox" className="mzn-chk" checked={northOn}
                                                                ref={(el) => {
                                                                    if (el) el.indeterminate =
                                                                        groups.north.some(g => g.checked) && !northOn;
                                                                }}
                                                                onChange={(e) => this.setGovGroup(groups.north, e.target.checked)} />
                                                            تأشير المجموعة
                                                        </label>
                                                        <span className="mzn-grp-price">
                                                            سعر موحّد
                                                            <input type="text" inputMode="decimal" className="mzn-mini"
                                                                value={s.balNorthPrice || ''}
                                                                onChange={(e) => {
                                                                    const v = e.target.value;
                                                                    if (v === '' || /^\d*\.?\d*$/.test(v)) {
                                                                        this.setState({ balNorthPrice: v });
                                                                        if (v !== '') this.setGovGroupPrice(groups.north, v);
                                                                    }
                                                                }} />
                                                        </span>
                                                    </div>
                                                </td></tr>
                                            )}
                                            {this.renderGovRows(groups.north)}

                                            {groups.rest.length > 0 && (
                                                <tr className="mzn-grp"><td colSpan={4}>
                                                    <div className="mzn-grp-in">
                                                        <span className="mzn-grp-title">باقي المحافظات</span>
                                                        <label className="mzn-grp-act">
                                                            <input type="checkbox" className="mzn-chk"
                                                                checked={groups.rest.length > 0 && groups.rest.every(g => g.checked)}
                                                                ref={(el) => {
                                                                    if (el) el.indeterminate =
                                                                        groups.rest.some(g => g.checked) &&
                                                                        !groups.rest.every(g => g.checked);
                                                                }}
                                                                onChange={(e) => this.setGovGroup(groups.rest, e.target.checked)} />
                                                            تأشير المجموعة
                                                        </label>
                                                    </div>
                                                </td></tr>
                                            )}
                                            {this.renderGovRows(groups.rest)}

                                            {ready && p.baghdadCount > 0 && (
                                                <tr className="mzn-row is-anchor">
                                                    <td>بغداد <span className="mzn-muted">— الموازِن</span></td>
                                                    <td className="mzn-n">{p.baghdadCount}</td>
                                                    <td className="mzn-n">{Number(s.balBaghdadPrice)}</td>
                                                    <td className="mzn-n">
                                                        {Math.round(p.baghdadCount * Number(s.balBaghdadPrice) * 100) / 100}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {/* ── المواد ── */}
                        <div className="mzn-pane">
                            <div className="mzn-pane-head">
                                <span className="mzn-eyebrow">المواد</span>
                                <label className="mzn-all">
                                    <input type="checkbox" className="mzn-chk"
                                        checked={s.balItems.length > 0 && s.balItems.every(it => it.checked)}
                                        ref={(el) => {
                                            if (el) el.indeterminate =
                                                s.balItems.some(it => it.checked) && !s.balItems.every(it => it.checked);
                                        }}
                                        onChange={(e) => this.setAllItems(e.target.checked)} />
                                    حدد الجميع
                                </label>
                            </div>
                            <div className="mzn-scroll">
                                {items.length === 0 ? (
                                    <div className="mzn-empty">ما فيه مواد بالطلبات المعلّقة</div>
                                ) : (
                                    <table className="mzn-t">
                                        <thead>
                                            <tr>
                                                {this.sortTh('item', 'name', 'المادة')}
                                                {this.sortTh('item', 'stock', 'بالمخزن', 'mzn-n')}
                                                {this.sortTh('item', 'wanted', 'مطلوب', 'mzn-n')}
                                                {this.sortTh('item', 'short', 'النقص', 'mzn-n')}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((it) => {
                                                const i = s.balItems.indexOf(it);
                                                const short = it.wanted - it.stock;
                                                return (
                                                    <tr key={it.id} className={'mzn-row ' + (it.checked ? '' : 'is-off')}>
                                                        <td>
                                                            <label className="mzn-name">
                                                                <input type="checkbox" className="mzn-chk" checked={it.checked}
                                                                    onChange={(e) => this.setBalItem(i, e.target.checked)} />
                                                                <span className="mzn-item-name">{it.name}</span>
                                                            </label>
                                                        </td>
                                                        <td className="mzn-n">
                                                            <span className={'mzn-stock ' + (short > 0 ? 'is-short' : '')}>
                                                                {it.stock}
                                                            </span>
                                                        </td>
                                                        <td className="mzn-n mzn-muted">{it.wanted}</td>
                                                        <td className="mzn-n">
                                                            {short > 0
                                                                ? <span className="mzn-stock is-short">{short}</span>
                                                                : <span className="mzn-muted">—</span>}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>

                    {ready && p.warnings.map((w, i) => (
                        <div key={i} className="mzn-note">⚠️<span>{w}</span></div>
                    ))}

                    {ready && p.shortItems.length > 0 && (
                        <div className="mzn-note is-short">
                            ⛔<span>
                                <b>{p.shortCount} طلب</b> بضاعتها ما تكفي — تنأشّر وتظهر بالأحمر بالجدول:
                                {' '}
                                {p.shortItems.map((it) => (
                                    <span key={it.id} className="mzn-short-tag">
                                        {it.name}: بالمخزن {it.stock} · ناقص {it.missing}
                                    </span>
                                ))}
                            </span>
                        </div>
                    )}

                    {ready && p.lookalikes.length > 0 && (
                        <div className="mzn-note is-info">
                            ⟲<span>
                                صيغتان لنفس المحافظة: {p.lookalikes.map(a => a.join(' / ')).join(' · ')}.
                                كل وحدة تنسعّر لحالها لأن الطلبات مخزونة بنصّين مختلفين.
                            </span>
                        </div>
                    )}

                    <p className="mzn-foot">
                        الطلبات ذات البضاعة الصفر مستثناة · الأقدم أولاً داخل كل محافظة ·
                        المحافظات المختارة تاخذ البضاعة قبل بغداد · التأشير يستبدل أي تحديد حالي
                    </p>
                </div>
            </Dialog>
        );
    }

    handleRowClicked = row => {
        let out = false

        let selectditems = this.state.selectedData;
        let t_price = 0
        let check = this.state.selectedData.find((item) => item.id === row.id)
        if (check) {
            t_price = 0
            selectditems = this.state.selectedData.filter((item) => item.id !== row.id)

            row.ordersFormItems.map((item) => {

                let objIndex = counts.findIndex(obj => obj.id == item.components.id);
                counts[objIndex].count = counts[objIndex].count + item.count
            })
            document.getElementById(row.id).innerText = ""



            out = false;
        } else {
            let div = document.getElementById(row.id)

            let items_r = ``
            row.ordersFormItems.map((item) => {

                let objIndex = counts.findIndex(obj => obj.id == item.components.id);
                counts[objIndex].count = counts[objIndex].count - item.count
                items_r = `${items_r}  ${item.components.name + " :" + counts[objIndex].count}`





                var span = document.createElement('p');
                span.className = 'content';
                var text = document.createTextNode(`${item.components.name + " :" + counts[objIndex].count}`);

                // span.style.color="#ffc107"
                span.appendChild(text);


                if (counts[objIndex].count < 0) {

                    out = true
                    span.style.color = "#ffc107"


                } else {
                    span.style.color = "#fafafa"
                }

                div.appendChild(span)
            })






            t_price = 0
            selectditems.push(row)


            // var span = document.createElement('span');
            // span.className = 'content';
            // var text = document.createTextNode("You got this!");
            // span.style.color = "#fafafa"
            // // span.style.color="#ffc107"
            // span.appendChild(text);
            // div.appendChild(span)


            console.log(row);
        }


        for (let index = 0; index < selectditems.length; index++) {
            t_price = t_price + Number(selectditems[index].price) - this.shipPriceFor(selectditems[index].government)
        }
        t_price = Math.round(t_price * 100) / 100
        toast(t_price, {
            position: "bottom-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });

        const updatedData = this.state.orders.map(item => {
            if (row.id !== item.id) {
                return item;
            }

            return {
                ...item,
                seleced: !item.seleced,
                out: out
            };
        });



        this.setState({ orders: updatedData, selectedData: selectditems, price: t_price })
        // setData(updatedData);
    };


    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        // عرض السبنر عند تحميل البيانات
                        if (this.state.isLoading) {
                            return (
                                <div style={{ 
                                    width: '100%', 
                                    height: 'calc(100vh - 60px)', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    flexDirection: 'column'
                                }}>
                                    <Spinner size={64} />
                                    <h3 style={{ marginTop: 20, color: '#007bff' }}>جاري تحميل البيانات...</h3>
                                </div>
                            )
                        }

                        return (
                            <div >
                                <br />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                                    <div style={{ textAlign: 'left', marginRight: '20px' }}>
                                        <div style={{ fontSize: "25px", fontWeight: "bold", color: '#007bff' }}>
                                            المبلغ {this.state.price}
                                        </div>

                                        {this.renderBalanceDialog()}

                                        <button
                                            className="btn btn-warning"
                                            style={{ marginTop: 8, fontWeight: 'bold' }}
                                            onClick={this.openBalance}
                                        >
                                            ⚖️ موازنة التوصيل
                                        </button>

                                        {this.state.selectedData.length > 0 && (
                                            <button
                                                className="btn btn-outline-secondary"
                                                style={{ marginTop: 8, marginRight: 8 }}
                                                onClick={this.clearSelection}
                                            >
                                                مسح التحديد
                                            </button>
                                        )}

                                        {this.state.balApplied && (
                                            <div style={{ marginTop: 8, fontSize: 15, fontWeight: 'bold', color: '#1b7a1b' }}>
                                                مؤشَّر {this.state.balApplied.count} طلب ·
                                                معدّل التوصيل {Math.round(this.state.balApplied.avg * 100) / 100}
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ textAlign: 'right', marginRight: '15px' }}>
                                        <Component initialState={{ isShown: false, items: [], notes: "", spin: true, check: 0, isPrinting: false }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        onCloseComplete={() => {
                                                            setState({ isShown: false, check: 0, isPrinting: false })
                                                            this.setState({ company: 'none' })
                                                        }}
                                                        confirmLabel={state.isPrinting ? "جاري الطباعة..." : "طباعة"}
                                                        isConfirmDisabled={state.isPrinting}
                                                        intent="success"
                                                        hasFooter={true}
                                                        title={" طباعة وصولات"}
                                                        onConfirm={() => {

                                                            if (state.check === 0) {
                                                                // التحقق من اختيار المندوب أولاً
                                                                if (this.state.company === "none") {
                                                                    toast.error('يرجى اختيار المندوب', {
                                                                        position: "top-center",
                                                                        autoClose: 3000,
                                                                    });
                                                                    return;
                                                                }

                                                                setState({ check: 1, isPrinting: true }) // بدء السبنر
                                                                
                                                                var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("token") };
                                                                let formData = new FormData();
                                                                for (let i = 0; i < this.state.selectedData.length; i++) {
                                                                    formData.append("orders_id", this.state.selectedData[i].id);
                                                                }
                                                                formData.append("name", this.state.company);

                                                                axios({ url: host + `users/orders/prints`, method: "POST", data: formData, headers: header })
                                                                    .then(response => {
                                                                        setState({ isPrinting: false }) // إيقاف السبنر

                                                                        if (this.state.company == "الوسيط") {
                                                                            window.location.href = `/dayle_orders?id=${response.data.data.print.id}`
                                                                        } else {
                                                                            window.location.replace(`https://pages.enfirad.com/Print2/${response.data.data.print.id}`);
                                                                        }
                                                                    })
                                                                    .catch(error => { 
                                                                        console.log(error)
                                                                        setState({ isPrinting: false, isShown: false, check: 0 }) // إيقاف السبنر
                                                                        toast.error("حدث خطأ في الطباعة", {
                                                                            position: "top-center",
                                                                            autoClose: 3000,
                                                                        });
                                                                    })
                                                            } else {
                                                                setState({ isShown: false, check: 0, isPrinting: false })
                                                            }
                                                        }}
                                                    >
                                                        <div style={{ direction: 'rtl', textAlign: 'center' }} >
                                                            {state.isPrinting ? (
                                                                <div style={{ 
                                                                    display: 'flex', 
                                                                    flexDirection: 'column', 
                                                                    alignItems: 'center', 
                                                                    justifyContent: 'center',
                                                                    padding: '20px'
                                                                }}>
                                                                    <Spinner size={48} />
                                                                    <p style={{ marginTop: 15, fontSize: 16, color: '#007bff' }}>
                                                                        جاري طباعة الوصولات...
                                                                    </p>
                                                                </div>
                                                            ) : (
                                                                <SelectField 
                                                                    label="مندوب التوصيل"
                                                                    id="SelectField"
                                                                    onChange={(e) => {
                                                                        this.setState({ company: e.target.value })
                                                                    }}
                                                                    required
                                                                >
                                                                    <option value={"none"}>اختر المندوب</option>
                                                                    {this.state.shiper.map((item, index) => (
                                                                        <option key={index} value={item.name}>{item.name}</option>
                                                                    ))}
                                                                </SelectField>
                                                            )}
                                                        </div>
                                                    </Dialog>
                                                    <Button 
                                                        marginLeft={30} 
                                                        marginTop={5} 
                                                        disabled={this.state.selectedData.length > 0 ? false : true} 
                                                        appearance="primary"
                                                        iconBefore={LocalPrintshopIcon}
                                                        onClick={() => {
                                                            setState({ isShown: true, spin: true })
                                                        }}
                                                        height={45}
                                                    >
                                                        طباعة {this.state.selectedData.length} وصل
                                                    </Button>
                                                </Pane>
                                            )}
                                        </Component>

                                        <br></br>
                                        <br></br>
                                        <br></br>
                                    </div>
                                </div>


                                <div>
                                    <div className='DataTableContiner'>
                                        <DataTable 
                                            title="طباعة وصلات" 
                                            highlightOnHover
                                            pointerOnHover 
                                            direction={'center'}
                                            conditionalRowStyles={conditionalRowStyles}
                                            customStyles={customStyles}
                                            columns={columns}
                                            data={this.state.orders}
                                            onRowClicked={this.handleRowClicked}
                                            onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
                                                this.setState({ selectedData: selectedRows })
                                            }}
                                        />
                                    </div>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                    }}
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}


export default Selles_Reports;